'use client';
import { sendGTMEvent } from '../sendGTMEvent';
import { productListItemToGAItem } from '../productMappers/productListItemToGAItem';
import { getSelectItemData } from '../itemSelectionUtils';
import type { CommerceModel } from 'api-types';

/**
 * Tracks the remove_from_cart event when users remove items from their basket.
 * 
 * This function sends a GA4 remove_from_cart event with the removed item details,
 * including the quantity removed, total value, and currency information.
 * 
 * @param product - The line item being removed from the cart
 * @param quantity - The quantity being removed (defaults to 1)
 */
export const trackRemoveFromCart = (
  product: CommerceModel.LineItem,
  quantity: number | undefined = 1,
) => {
  // Extract product selection context
  const selectItemData = getSelectItemData(product.productId, product.productId);

  // Calculate removal value and currency
  const productCurrency = product.priceOutput?.currency || 'DKK';
  const unitPrice = product.priceOutput?.totalPrice?.taxedPrice || 0;

  // Map product to GA4 item format
  const gaItem = productListItemToGAItem(product, {
    listId: selectItemData?.item_list_id,
    listName: selectItemData?.item_list_name,
    index: selectItemData?.index,
    quantity,
  });

  sendGTMEvent({
    event: 'remove_from_cart',
    ecommerce: {
      currency: productCurrency,
      value: unitPrice,
      items: [gaItem],
    },
  });
};
